<template>
  <div class="timer">
    {{ mm }}:{{ ss }}
  </div>
</template>

<script>
export default {
  name: 'Timer',
  data: function () {
    return {
      isRunning: true,
      timer: Number,
      startTime: Number,
    }
  },
  computed: {
    mm: function() { 
      var val = Math.trunc((this.timer - this.startTime)/60000); 
      return "" + val > 9? val: "0" + val; 
    },
    ss: function() { 
      var val = Math.trunc((this.timer - this.startTime)/1000)%60; 
      return "" + val > 9? val: "0" + val; 
    }
  },
  mounted: function () {
    window.setInterval(() => {
      if(this.isRunning) {
        this.timer = Date.now();
      }
    }, 200);
    this.startTime = Date.now();

  },
  methods: {
    stopTimer: function () {
      this.isRunning = false;
    },
    startTimer: function () {
      this.isRunning = true;
    },
    resetTimer: function () {
      this.startTime = Date.now();
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .timer {
    font-size: 18px;
    height:24px;
    width:64px;
    line-height: 24px;
    font-family: 'Overpass Mono', monospace;
    color: #99ee99;
    text-align: center;
    background: #342;
    /*box-shadow: 0 0 10px #897;*/
    box-shadow: 0 0 10px #1d2316a8;
    text-shadow: 0 0 10px #99ee99;
  }
</style>
